import { authHeaders, baseUrl, handleResponse } from './apiUtils';

async function listEvents(filters) {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length) query.set(key, value.join(','));
    else if (value && !Array.isArray(value)) query.set(key, value);
  });
  const response = await fetch(`${baseUrl}audit/events?${query.toString()}`, { headers: authHeaders() });
  if (response.status === 400) {
    const body = await response.json();
    const messages = {
      'Invalid date range': 'Data „Od” nie może być późniejsza niż data „Do”.',
      'Invalid date': 'Podaj poprawną datę.',
      'Invalid filter': 'Sprawdź wybrane filtry.',
      'Invalid cursor': 'Strona wyników wygasła. Zmień filtr, aby rozpocząć od nowa.',
    };
    throw new Error(messages[body.error] || 'Nieprawidłowe filtry dziennika.');
  }
  return handleResponse(response);
}

async function getEvent(eventId) {
  const response = await fetch(`${baseUrl}audit/events/${encodeURIComponent(eventId)}`, { headers: authHeaders() });
  return handleResponse(response);
}

async function getCapabilities() {
  const response = await fetch(`${baseUrl}audit/capabilities`, { headers: authHeaders() });
  return handleResponse(response, false);
}

async function getActors() {
  const actors = [];
  let cursor = null;
  for (let page = 0; page < 20; page += 1) {
    const query = cursor ? `?cursor=${encodeURIComponent(cursor)}` : '';
    // eslint-disable-next-line no-await-in-loop
    const response = await fetch(`${baseUrl}audit/actors${query}`, { headers: authHeaders() });
    // eslint-disable-next-line no-await-in-loop
    const result = await handleResponse(response);
    actors.push(...result.items);
    if (!result.cursor || result.cursor === cursor) break;
    cursor = result.cursor;
  }
  return actors;
}

export default { listEvents, getEvent, getCapabilities, getActors };
